import { Component } from '@angular/core';

@Component({
    selector: 'app-references-order-product-select-value-empty',
    templateUrl: './references-order-product-select-value-empty.component.html',
    styleUrls: ['./references-order-product-select-value-empty.component.less'],
    standalone: false,
})
export class ReferencesOrderProductSelectValueEmptyComponent { }
